<template>
    <div class="filter-group">
        <button
            @click="active = !active"
            class="btn filter-btn filter-title collapsed mb-0"
            type="button"
            data-toggle="collapse"
            :data-target="`#${id}`"
            :aria-expanded="active"
            :aria-controls="id"
        >
            {{ title }}
            <filter-label
                @close="setFilter([])"
                class="text-uppercase ml-3 mr-auto"
                :background-color="backgroundColor"
                :color="color"
                :text="localSelected.length.toString()"
                v-if="clear && localSelected.length"
            />
            <a-icon icon="Dropdown" />
        </button>
        <div class="collapse" :class="{ show: active }" :id="id">
            <ui-checkbox-input
                v-if="firstOption"
                class="text-sm"
                :name="title"
                v-model="selectAll"
                :label="firstOption"
                @change="val => val && setFilter([])"
            />
            <ui-checkbox-input
                class="text-sm"
                v-for="(option, id) in options"
                :key="id"
                :name="title + '-' + id"
                @change="val => onFilterChange(option, val)"
                :value="selected.some(r => selected.includes(option.value))"
                :label="dict ? dict[option.label] : option.label"
                :tooltip="option.tooltip"
                :tooltip-label="option.tooltipLabel"
                :disabled="option.disabled"
            />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active: false
            // selectAll: true
        }
    },
    props: {
        id: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        selected: {
            type: Array
        },
        dict: {
            type: Object,
            required: false
        },
        firstOption: {
            type: String,
            required: false
        },
        clear: {
            type: Boolean,
            default: false
        },
        backgroundColor: {
            type: String,
            required: false
        },
        color: {
            type: String,
            required: false
        },
        singleSelect: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localSelected: {
            get() {
                return this.selected
            },
            set(value) {
                if (!value.includes(0)) {
                    this.$emit('set-filter', value)
                }
            }
        },
        selectAll: {
            get() {
                return this.selected.length === 0
            },
            set(value) {
                if (value) {
                    this.$emit('set-filter', [])
                }
            }
        }
    },
    created() {
        if (this.selected.length > 0) {
            this.active = true
        }
    },
    watch: {
        localSelected: {
            handler() {
                if (this.selected.length > 0) {
                    this.active = true
                }
            }
        }
    },
    methods: {
        setFilter(value) {
            this.$emit('set-filter', value)
        },

        onFilterChange(option, checked) {
            let tmp = this.localSelected

            if (checked) {
                tmp.push(option.value)
            } else {
                tmp = tmp.filter(e => e !== option.value)
            }

            this.setFilter(
                this.singleSelect && checked ? [option.value] : tmp
            )
        }
    }
}
</script>

<style lang="scss">
.filter-group {
    margin-bottom: 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
</style>